<template>
  <div>
    <!--...................ImageUploadButton...................-->
    <div
      class="dz-add d-flex align-items-center"
      v-if="mode === 'image' && add"
    >
      <b-button
        variant="ps-base"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1 ps-transform"
        @click="showFilesModal"
      >
        <b-icon-cloud-upload-fill class="ms-1" />
        {{ label.dropZone.uploadImg }}
      </b-button>
    </div>
    <!--...................MultipleImageUploadButton...................-->
    <div
      class="dz-add d-flex align-items-center"
      v-if="mode === 'multipleImage' && add"
    >
      <b-button
        variant="ps-base"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1 ps-transform"
        @click="showFilesModal"
      >
        <b-icon-cloud-upload-fill class="ms-1" />
        {{ label.dropZone.upload }}
      </b-button>
    </div>
    <!--...................ThumbUploadButton...................-->
    <div
      class="dz-add d-flex align-items-center"
      v-if="mode === 'thumb' && add"
    >
      <b-button
        variant="ps-base"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1 ps-transform"
        @click="showFilesModal"
      >
        <b-icon-cloud-upload-fill class="ms-1" />
        {{ label.dropZone.upload }} {{ editText }}
      </b-button>
    </div>
    <!--...................VideoUploadButton...................-->
    <div
      class="dz-add d-flex align-items-center"
      v-if="mode === 'video' && add"
    >
      <b-button
        variant="ps-base"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1 ps-transform"
        @click="showFilesModal"
      >
        <b-icon-cloud-upload-fill class="ms-1" />
        {{ label.dropZone.uploadVideo }}
      </b-button>
    </div>
    <!--...................SoundUploadButton...................-->
    <div
      class="dz-add d-flex align-items-center"
      v-if="mode === 'sound' && add"
    >
      <b-button
        variant="ps-base"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1 ps-transform"
        @click="showFilesModal"
      >
        <b-icon-cloud-upload-fill class="ms-1" />
        {{ label.dropZone.uploadVoice }}
      </b-button>
    </div>
    <!--...................FileUploadButton...................-->
    <div class="dz-add d-flex align-items-center" v-if="mode === 'file' && add">
      <b-button
        variant="ps-base"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1 ps-transform"
        @click="showFilesModal"
      >
        <b-icon-cloud-upload-fill class="ms-1" />
        {{ label.dropZone.uploadFile }}
      </b-button>
    </div>

    <!--...................ImageEditBox...................-->
    <div
      class="dz-edit d-flex align-items-center"
      v-if="mode === 'image' && edit && !add"
    >
      <img :src="editSrc" />
      <b-button
        variant="ps-warning"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1"
        @click="showFilesModal"
      >
        <b-icon-pencil-square />
        {{ label.dropZone.editImg }}
      </b-button>
    </div>
    <!--...................MultipleImageEditBox...................-->
    <div
      class="dz-edit d-flex align-items-center"
      v-if="mode === 'multipleImage' && edit && !add"
    >
      <div class="file-box-icon-edit">
        <b-icon icon="file-earmark-image" />
      </div>
      <b-button
        variant="ps-warning"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1"
        @click="showFilesModal"
      >
        <b-icon-pencil-square />
        {{ label.dropZone.editImg }}
      </b-button>
    </div>
    <!--...................ThumbEditBox...................-->
    <div
      class="dz-edit d-flex align-items-center"
      v-if="mode === 'thumb' && edit && !add"
    >
      <img :src="editSrc" />
      <b-button
        variant="ps-warning"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1"
        @click="showFilesModal"
      >
        <b-icon-pencil-square />
        {{ label.dropZone.edit }}  {{ editText }}
      </b-button>
    </div>
    <!--...................VideoEditBox...................-->
    <div
      class="dz-edit d-flex align-items-center"
      v-if="mode === 'video' && edit && !add"
    >
      <div class="file-box-icon-edit">
        <b-icon icon="file-earmark-play" />
      </div>
      <b-button
        variant="ps-warning"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1"
        @click="showFilesModal"
      >
        <b-icon-pencil-square />
        {{ label.dropZone.editVideo }}
      </b-button>
    </div>
    <!--...................SoundEditBox...................-->
    <div
      class="dz-edit d-flex align-items-center"
      v-if="mode === 'sound' && edit && !add"
    >
      <div class="file-box-icon-edit">
        <b-icon icon="file-earmark-music" />
      </div>
      <b-button
        variant="ps-warning"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1"
        @click="showFilesModal"
      >
        <b-icon-pencil-square />
        {{ label.dropZone.editVoice }}
      </b-button>
    </div>
    <!--...................FileEditBox...................-->
    <div
      class="dz-edit d-flex align-items-center"
      v-if="mode === 'file' && edit && !add"
    >
      <div class="file-box-icon-edit">
        <b-icon icon="file-earmark-excel" v-if="extension === '.xlsx'" />
        <b-icon icon="file-earmark-text" v-if="extension === '.pdf'" />
        <b-icon icon="file-earmark-word" v-if="extension === '.docx'" />
        <b-icon icon="file-earmark-word" v-if="extension === '.doc'" />
        <b-icon icon="file-earmark-text" v-if="extension === '.txt'" />
        <b-icon icon="file-earmark-zip" v-if="extension === '.zip'" />
        <b-icon icon="file-earmark-text" v-if="!extension" />
      </div>
      <b-button
        variant="ps-warning"
        size="sm"
        class="dz-clear-btn mx-1 px-3 py-1"
        @click="showFilesModal"
      >
        <b-icon-pencil-square />
        {{ label.dropZone.editFile }}
      </b-button>
    </div>

    <!--...................ImageUploader...................-->
    <dropZone
      v-if="mode === 'image' && !edit && !add"
      id="image"
      class="w-100"
      ref="imageDropzone"
      :options="dropzoneImageOptions"
      :duplicateCheck="true"
      :useCustomSlot="true"
      @vdropzone-success="imageSuccess"
      @vdropzone-error="dropZoneError"
      @vdropzone-max-files-exceeded="dropZoneMaxError"
    >
      <b-row class="justify-content-center m-0 p-0">
        <b-col cols="auto" class="m-0 p-0">
          <p class="mb-2 fa-text fs-medium fw-bold">{{ label.dropZone.uploadImg }}</p>
        </b-col>
        <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
          <span class="ps_label_star">*</span>
        </b-col>
      </b-row>
      <p class="fs-normal mb-1 fa-text">
        <img src="/img/static/cloud-dropzone.png" width="30px" class="ms-2" />
         {{ label.dropZone.drag }}
      </p>
      <small class="mb-2 fs-smal fa-text">
      {{ label.dropZone.MaxFormat }}</small
      >
    </dropZone>

    <!--...................AllUploader...................-->
    <dropZone
      v-if="mode === 'all' && !edit && !add"
      id="image"
      class="w-100"
      ref="imageDropzone"
      :options="dropzoneOptions"
      :duplicateCheck="true"
      :useCustomSlot="true"
      @vdropzone-success="allSuccess"
      @vdropzone-error="dropZoneError"
      @vdropzone-max-files-exceeded="dropZoneMaxError"
    >
      <b-row class="justify-content-center m-0 p-0">
        <b-col cols="auto" class="m-0 p-0">
          <p class="mb-2 fa-text fs-medium fw-bold"> {{ label.dropZone.uploadFile}}</p>
        </b-col>
        <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
          <span class="ps_label_star">*</span>
        </b-col>
      </b-row>
      <p class="fs-normal mb-1 fa-text">
        <img src="/img/static/cloud-dropzone.png" width="30px" class="ms-2" />
        {{ label.dropZone.drag }}
      </p>
    </dropZone>

    <!--...................ThumbImageUploader...................-->
    <dropZone
      v-if="mode === 'thumb' && !edit && !add"
      id="thumb"
      class="w-100"
      ref="thumbDropzone"
      :options="dropzoneImageOptions"
      :duplicateCheck="true"
      :useCustomSlot="true"
      @vdropzone-success="thumbSuccess"
      @vdropzone-error="dropZoneError"
      @vdropzone-max-files-exceeded="dropZoneMaxError"
    >
      <b-row class="justify-content-center m-0 p-0">
        <b-col cols="auto" class="m-0 p-0">
          <p class="mb-2 fa-text fs-medium fw-bold">{{ label.dropZone.upload }} {{ editText }}</p>
        </b-col>
        <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
          <span class="ps_label_star">*</span>
        </b-col>
      </b-row>
      <p class="fs-normal mb-1 fa-text">
        <img src="/img/static/cloud-dropzone.png" width="30px" class="ms-2" />
        {{ label.dropZone.drag }}
      </p>
      <small class="mb-2 fs-smal fa-text"
        >{{ label.dropZone.MaxFormat }}</small
      >
    </dropZone>

    <!--...................FileUploader...................-->
    <dropZone
      v-if="mode === 'file' && !edit && !add"
      id="File"
      class="w-100"
      ref="FileDropzone"
      :options="dropzoneFileOptions"
      :duplicateCheck="true"
      :useCustomSlot="true"
      @vdropzone-success="fileSuccess"
      @vdropzone-error="dropZoneError"
      @vdropzone-max-files-exceeded="dropZoneMaxError"
    >
      <b-row class="justify-content-center m-0 p-0">
        <b-col cols="auto" class="m-0 p-0">
          <p class="mb-2 fa-text fs-medium fw-bold">{{
            dropZone.uploadFile }}</p>
        </b-col>
        <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
          <span class="ps_label_star">*</span>
        </b-col>
      </b-row>
      <p class="fs-normal mb-1 fa-text">
        <img src="/img/static/cloud-dropzone.png" width="30px" class="ms-2" />
        {{ label.dropZone.drag }}
      </p>
      <small class="mb-2 fs-smal fa-text"
        >{{ label.dropZone.MaxFormat2 }}</small
      >
    </dropZone>

    <!--...................MultipleImageUploader...................-->
    <dropZone
      v-if="mode === 'multipleImage' && !edit && !add"
      id="image"
      class="w-100"
      ref="imageDropzone"
      :options="dropzoneMultipleOptions"
      :duplicateCheck="true"
      :useCustomSlot="true"
      @vdropzone-success-multiple="multipleImageSuccess"
      @vdropzone-error="dropZoneError"
      @vdropzone-max-files-exceeded="dropZoneMaxError"
    >
      <b-row class="justify-content-center m-0 p-0">
        <b-col cols="auto" class="m-0 p-0">
          <p class="mb-2 fa-text fs-medium fw-bold">{{ label.dropZone.uploadImg }}</p>
        </b-col>
        <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
          <span class="ps_label_star">*</span>
        </b-col>
      </b-row>
      <p class="fs-normal mb-1 fa-text">
        <img src="/img/static/cloud-dropzone.png" width="30px" class="ms-2" />
        {{ label.dropZone.drag }}
      </p>
      <small class="mb-2 fs-smal fa-text"
        >{{ label.dropZone.MaxFormat }}</small
      >
    </dropZone>

    <!--...................VideoUploader...................-->
    <dropZone
      v-if="mode === 'video' && !edit && !add"
      id="Video"
      class="w-100"
      ref="VideoDropzone"
      :options="dropzoneVideoOptions"
      :duplicateCheck="true"
      :useCustomSlot="true"
      @vdropzone-success="videoSuccess"
      @vdropzone-error="dropZoneError"
      @vdropzone-max-files-exceeded="dropZoneMaxError"
    >
      <b-row class="justify-content-center m-0 p-0">
        <b-col cols="auto" class="m-0 p-0">
          <p class="mb-2 fa-text fs-medium fw-bold">{{ label.dropZone.uploadVideo }}</p>
        </b-col>
        <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
          <span class="ps_label_star">*</span>
        </b-col>
      </b-row>
      <p class="fs-normal mb-1 fa-text">
        <img src="/img/static/cloud-dropzone.png" width="30px" class="ms-2" />
        {{ label.dropZone.drag }}
      </p>
      <small class="mb-2 fs-smal fa-text"
        >{{ label.dropZone.MaxFormat3 }}</small
      >
    </dropZone>

    <!--...................SoundUploader...................-->
    <dropZone
      v-if="mode === 'sound' && !edit && !add"
      id="Sound"
      class="w-100"
      ref="SoundDropzone"
      :options="dropzoneSoundOptions"
      :duplicateCheck="true"
      :useCustomSlot="true"
      @vdropzone-success="soundSuccess"
      @vdropzone-error="dropZoneError"
      @vdropzone-max-files-exceeded="dropZoneMaxError"
    >
      <b-row class="justify-content-center m-0 p-0">
        <b-col cols="auto" class="m-0 p-0">
          <p class="mb-2 fa-text fs-medium fw-bold">{{ label.dropZone.uploadVoice }}</p>
        </b-col>
        <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
          <span class="ps_label_star">*</span>
        </b-col>
      </b-row>
      <p class="fs-normal mb-1 fa-text">
        <img src="/img/static/cloud-dropzone.png" width="30px" class="ms-2" />
        {{ label.dropZone.drag }}
      </p>
      <small class="mb-2 fs-smal fa-text"
        > {{ label.dropZone.MaxFormat4 }} </small
      >
    </dropZone>

    <!--...................ModalUploader...................-->
    <b-modal
      dir="rtl"
      v-model="showModal"
      size="xl"
      scrollable
      header-bg-variant="ps-first"
      centered
    >
      <template #modal-header>
        <h4 class="text-light m-0 fw1">
          {{ label.dropZone.manageFile }}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="showModal = false"
          v-b-tooltip.hover
          :title="label.dropZone.closeTab"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <div class="files-modal-list">
          <b-row>
            <b-col
              v-show="files && files.length > 0"
              v-for="file in files"
              :key="file.id"
              lg="2"
              md="4"
              sm="6"
              class="px-3 py-2"
            >
              <div
                :id="'file-box' + file.id"
                class="files-box"
                dir="ltr"
                @click="selectFile(file)"
              >
                <b-icon-check-circle-fill
                  class="files-box-check-icon"
                  :id="'files-box-check-icon' + file.id"
                  scale="1.9"
                  variant="success"
                />
                <img
                  class="image-contain"
                  :src="file.fileAddress"
                  :alt="file.title"
                  v-if="
                    file.extension === '.jpg' ||
                    file.extension === '.JPG' ||
                    file.extension === '.png' ||
                    file.extension === '.PNG' ||
                    file.extension === '.jpeg' ||
                    file.extension === '.webp' ||
                    file.extension === '.gif'
                  "
                />
                <div class="file-box-icon" v-else>
                  <b-icon
                    icon="file-earmark-excel"
                    v-if="file.extension === '.xlsx'"
                  />
                  <b-icon
                    icon="file-earmark-pdf"
                    v-if="file.extension === '.pdf'"
                  />
                  <b-icon
                    icon="file-earmark-word"
                    v-if="
                      file.extension === '.docx' || file.extension === '.doc'
                    "
                  />
                  <b-icon
                    icon="file-earmark-text"
                    v-if="file.extension === '.txt'"
                  />
                  <b-icon
                    icon="file-earmark-zip"
                    v-if="file.extension === '.zip'"
                  />
                  <b-icon
                    icon="file-earmark-play"
                    v-if="
                      file.extension === '.mp4' || file.extension === '.mkv'
                    "
                  />
                  <b-icon
                    icon="file-earmark-music"
                    v-if="
                      file.extension === '.mp3' || file.extension === '.wav'
                    "
                  />
                </div>
                <h5 dir="ltr" v-if="file.title" class="mt-2 mb-0">
                  {{ file.title | charactersLimit(19) }}
                </h5>
                <h5 dir="ltr" v-else class="mt-2 mb-0">
                  {{ file.fileName | charactersLimit(19) }}
                </h5>
              </div>
            </b-col>
            <b-col
              v-if="files.length <= 0"
              cols="12"
              class="align-self-center text-center mt-2"
            >
              <p class="m-0 text-ps-secondary">
                {{ label.dropZone.noFile }}
              </p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="showModal = false"
            >
            {{ label.dropZone.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-base"
              size="sm"
              class="mx-1 ps-transform"
              @click="addFileModal = true"
            >
              <b-icon-cloud-upload-fill class="ms-1" />
              {{ label.dropZone.newUploadFile }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="sendFile"
            >
              {{ label.dropZone.recordFile }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!--...................AddModalUploader...................-->
    <b-modal
      dir="rtl"
      v-model="addFileModal"
      header-bg-variant="ps-success"
      centered
      hide-footer
    >
      <template #modal-header>
        <h4 class="text-white fw1 m-0">
          {{ label.dropZone.uploadFile}}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="addFileModal = false"
          v-b-tooltip.hover
          :title="label.dropZone.closeTab"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col v-if="mode === 'image' || mode === 'hide'" sm="12">
            <dropZone
              id="image"
              class="w-100"
              ref="imageDropzone"
              :options="dropzoneImageOptions"
              :duplicateCheck="true"
              :useCustomSlot="true"
              @vdropzone-success="imageSuccess"
              @vdropzone-error="dropZoneError"
              @vdropzone-max-files-exceeded="dropZoneMaxError"
            >
              <b-row class="justify-content-center m-0 p-0">
                <b-col cols="auto" class="m-0 p-0">
                  <p class="mb-2 fa-text fs-medium fw-bold"> {{ label.dropZone.uploadImg}}</p>
                </b-col>
                <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
                  <span class="ps_label_star">*</span>
                </b-col>
              </b-row>
              <p class="fs-normal mb-1 fa-text">
                <img
                  src="/img/static/cloud-dropzone.png"
                  width="30px"
                  class="ms-2"
                />
                {{ label.dropZone.drag }}
              </p>
              <small class="mb-2 fs-smal fa-text"
                >{{ label.dropZone.MaxFormat}}</small
              >
            </dropZone>
          </b-col>
          <b-col v-if="mode === 'thumb'" sm="12">
            <dropZone
              id="thumb"
              class="w-100"
              ref="thumbDropzone"
              :options="dropzoneImageOptions"
              :duplicateCheck="true"
              :useCustomSlot="true"
              @vdropzone-success="thumbSuccess"
              @vdropzone-error="dropZoneError"
              @vdropzone-max-files-exceeded="dropZoneMaxError"
            >
              <b-row class="justify-content-center m-0 p-0">
                <b-col cols="auto" class="m-0 p-0">
                  <p class="mb-2 fa-text fs-medium fw-bold">
                    {{ label.dropZone.upload}} {{ editText }}
                  </p>
                </b-col>
                <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
                  <span class="ps_label_star">*</span>
                </b-col>
              </b-row>
              <p class="fs-normal mb-1 fa-text">
                <img
                  src="/img/static/cloud-dropzone.png"
                  width="30px"
                  class="ms-2"
                />
                {{ label.dropZone.drag }}
              </p>
              <small class="mb-2 fs-smal fa-text"
                >{{ label.dropZone.MaxFormat }}</small
              >
            </dropZone>
          </b-col>
          <b-col v-if="mode === 'file'" sm="12">
            <dropZone
              id="File"
              class="w-100"
              ref="FileDropzone"
              :options="dropzoneFileOptions"
              :duplicateCheck="true"
              :useCustomSlot="true"
              @vdropzone-success="fileSuccess"
              @vdropzone-error="dropZoneError"
              @vdropzone-max-files-exceeded="dropZoneMaxError"
            >
              <b-row class="justify-content-center m-0 p-0">
                <b-col cols="auto" class="m-0 p-0">
                  <p class="mb-2 fa-text fs-medium fw-bold"> {{ label.dropZone.uploadFile }}</p>
                </b-col>
                <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
                  <span class="ps_label_star">*</span>
                </b-col>
              </b-row>
              <p class="fs-normal mb-1 fa-text">
                <img
                  src="/img/static/cloud-dropzone.png"
                  width="30px"
                  class="ms-2"
                />
                {{ label.dropZone.drag }}
              </p>
              <small class="mb-2 fs-smal fa-text"
                >{{ label.dropZone.MaxFormat2 }}</small
              >
            </dropZone>
          </b-col>
          <b-col v-if="mode === 'multipleImage'" sm="12">
            <dropZone
              id="image"
              class="w-100"
              ref="imageDropzone"
              :options="dropzoneMultipleOptions"
              :duplicateCheck="true"
              :useCustomSlot="true"
              @vdropzone-success="multipleImageSuccess"
              @vdropzone-error="dropZoneError"
              @vdropzone-max-files-exceeded="dropZoneMaxError"
            >
              <b-row class="justify-content-center m-0 p-0">
                <b-col cols="auto" class="m-0 p-0">
                  <p class="mb-2 fa-text fs-medium fw-bold">{{ label.dropZone.uploadImg }}</p>
                </b-col>
                <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
                  <span class="ps_label_star">*</span>
                </b-col>
              </b-row>
              <p class="fs-normal mb-1 fa-text">
                <img
                  src="/img/static/cloud-dropzone.png"
                  width="30px"
                  class="ms-2"
                />
                {{ label.dropZone.drag }}
              </p>
              <small class="mb-2 fs-smal fa-text"
                >فرمت jpg و png و هر عکس حداکثر 1 مگابایت</small
              >
            </dropZone>
          </b-col>
          <b-col v-if="mode === 'video'" sm="12">
            <dropZone
              id="Video"
              class="w-100"
              ref="VideoDropzone"
              :options="dropzoneVideoOptions"
              :duplicateCheck="true"
              :useCustomSlot="true"
              @vdropzone-success="videoSuccess"
              @vdropzone-error="dropZoneError"
              @vdropzone-max-files-exceeded="dropZoneMaxError"
            >
              <b-row class="justify-content-center m-0 p-0">
                <b-col cols="auto" class="m-0 p-0">
                  <p class="mb-2 fa-text fs-medium fw-bold">{{ label.dropZone.uploadVideo }}</p>
                </b-col>
                <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
                  <span class="ps_label_star">*</span>
                </b-col>
              </b-row>
              <p class="fs-normal mb-1 fa-text">
                <img
                  src="/img/static/cloud-dropzone.png"
                  width="30px"
                  class="ms-2"
                />
                {{ label.dropZone.drag }}
              </p>
              <small class="mb-2 fs-smal fa-text"
                >{{ label.dropZone.MaxFormat3 }}</small
              >
            </dropZone>
          </b-col>
          <b-col v-if="mode === 'sound'" sm="12">
            <dropZone
              id="Sound"
              class="w-100"
              ref="SoundDropzone"
              :options="dropzoneSoundOptions"
              :duplicateCheck="true"
              :useCustomSlot="true"
              @vdropzone-success="soundSuccess"
              @vdropzone-error="dropZoneError"
              @vdropzone-max-files-exceeded="dropZoneMaxError"
            >
              <b-row class="justify-content-center m-0 p-0">
                <b-col cols="auto" class="m-0 p-0">
                  <p class="mb-2 fa-text fs-medium fw-bold"> {{ label.dropZone.uploadVoice }} </p>
                </b-col>
                <b-col v-if="isRequired" cols="auto" class="m-0 px-1">
                  <span class="ps_label_star">*</span>
                </b-col>
              </b-row>
              <p class="fs-normal mb-1 fa-text">
                <img
                  src="/img/static/cloud-dropzone.png"
                  width="30px"
                  class="ms-2"
                />
                {{ label.dropZone.drag }}
              </p>
              <small class="mb-2 fs-smal fa-text"
                >{{ label.dropZone.MaxFormat4 }}</small
              >
            </dropZone>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { dropZone } from "@/components/dropZone";
import { mapGetters } from "vuex";
import label from "@/plugins/StaticLabels.js";

export default {
  name: "DropZoneCustom",
  mixins: [dropZone],
  computed: {
    ...mapGetters({
      files: "baseX/files",
      addCheck: "addUploaderCheck",
      multipleImage2: "multipleImage2",
    }),
  },
  watch: {
    addCheck() {
      if (this.addCheck) {
        this.showFilesModal();
      }
    },
  },
  props: {
    mode: {
      type: String,
      default: "image",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    add: {
      type: Boolean,
      default: false,
    },
    editSrc: {
      type: String,
      default: null,
    },
    editText: {
      type: String,
      default: "پیش نمایش",
    },
    extension: {
      type: String,
      default: ".pdf",
    },
  },
  data() {
    return {
      showModal: false,
      addFileModal: false,
      title: null,
      selectedFile: null,
      selectedFilePath: [],
      label,
    };
  },
  methods: {
    selectFile(file) {
      let box = document.getElementById("file-box" + this.selectedFile);
      let checkIcon = document.getElementById(
        "files-box-check-icon" + this.selectedFile
      );
      let selectedBox = document.getElementById("file-box" + file.id);
      let selectedCheckIcon = document.getElementById(
        "files-box-check-icon" + file.id
      );

      if (this.mode === "multipleImage") {
        if (
          this.selectedFile !== file.id &&
          this.selectedFilePath.indexOf(file) === -1
        ) {
          const exItem = this.selectedFilePath.find(({ id }) => id === file.id);
          if (exItem) {
            selectedBox.classList.remove("selected-box");
            selectedCheckIcon.classList.remove("show-element");
            this.selectedFile = null;
            this.selectedFilePath.splice(
              this.selectedFilePath.indexOf(exItem),
              1
            );
          } else {
            selectedBox.classList.add("selected-box");
            selectedCheckIcon.classList.add("show-element");
            this.selectedFile = file.id;
            this.selectedFilePath.push(file);
          }
        } else if (this.selectedFilePath.indexOf(file) !== -1) {
          selectedBox.classList.remove("selected-box");
          selectedCheckIcon.classList.remove("show-element");
          this.selectedFile = null;
          this.selectedFilePath.splice(this.selectedFilePath.indexOf(file), 1);
        }
      } else {
        if (this.selectedFile && this.selectedFile !== file.id) {
          box.classList.remove("selected-box");
          checkIcon.classList.remove("show-element");
          selectedBox.classList.add("selected-box");
          selectedCheckIcon.classList.add("show-element");
          this.selectedFile = file.id;
          this.selectedFilePath = [file];
        } else if (this.selectedFile === file.id) {
          selectedBox.classList.remove("selected-box");
          selectedCheckIcon.classList.remove("show-element");
          this.selectedFile = null;
          this.selectedFilePath = [];
        } else {
          selectedBox.classList.add("selected-box");
          selectedCheckIcon.classList.add("show-element");
          this.selectedFile = file.id;
          this.selectedFilePath = [file];
        }
      }
    },
    showFilesModal() {
      setTimeout(() => {
        if (this.multipleImage2) {
          this.selectedFilePath = this.multipleImage2;
          this.selectedFilePath.forEach((item) => {
            let selectedBox = document.getElementById("file-box" + item.id);
            let selectedCheckIcon = document.getElementById(
              "files-box-check-icon" + item.id
            );
            selectedBox.classList.add("selected-box");
            selectedCheckIcon.classList.add("show-element");
          });
        } else {
          this.selectedFilePath = [];
        }
      }, 800);
      let payload = {};
      this.showModal = true;
      if (this.mode === "multipleImage" || this.mode === "thumb") {
        payload = {
          pageSize: 1000000,
          time: null,
          type: "image",
          fileTypeId: null,
        };
      } else {
        payload = {
          pageSize: 1000000,
          time: null,
          type: this.mode,
          fileTypeId: null,
        };
      }
      this.$store.commit("setUrlsEmpty");
      this.$store.dispatch("baseX/getFiles", payload);
    },
    sendFile() {
      this.$store.commit("setLoadingBtn", true);
      if (this.selectedFilePath && this.selectedFilePath.length > 0) {
        switch (this.mode) {
          case "image":
            this.$store.commit("setImageUrl", this.selectedFilePath);
            break;
          case "multipleImage":
            this.$store.commit("setMultipleImageUrl", this.selectedFilePath);
            break;
          case "thumb":
            this.$store.commit("setThumbUrl", this.selectedFilePath);
            break;
          case "file":
            this.$store.commit("setFileUrl", this.selectedFilePath);
            break;
          case "video":
            this.$store.commit("setVideoUrl", this.selectedFilePath);
            break;
          case "sound":
            this.$store.commit("setSoundUrl", this.selectedFilePath);
            break;
          case "url":
            this.$store.commit("setUrl", this.selectedFilePath);
            break;
          case "hide":
            this.$store.commit("setImageUrl", this.selectedFilePath);
            break;
        }
        this.showModal = false;
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit("setError", "فایلی انتخاب نشده است");
      }
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    imageSuccess(file, response) {
      this.$store.commit("setLoadingBtn", true);
      setTimeout(() => {
        this.$store.commit("setImageUrl", response.data);
        this.addFileModal = false;
        this.showModal = false;
      }, 800);
    },
    multipleImageSuccess(file, response) {
      this.$store.commit("setLoadingBtn", true);
      setTimeout(() => {
        this.$store.commit("setMultipleImageUrl", response.data);
        this.addFileModal = false;
        this.showModal = false;
      }, 800);
    },
    thumbSuccess(file, response) {
      this.$store.commit("setLoadingBtn", true);
      setTimeout(() => {
        this.$store.commit("setThumbUrl", response.data);
        this.addFileModal = false;
        this.showModal = false;
      }, 800);
    },
    fileSuccess(file, response) {
      this.$store.commit("setLoadingBtn", true);
      setTimeout(() => {
        this.$store.commit("setFileUrl", response.data);
        this.addFileModal = false;
        this.showModal = false;
      }, 800);
    },
    videoSuccess(file, response) {
      this.$store.commit("setLoadingBtn", true);
      setTimeout(() => {
        this.$store.commit("setVideoUrl", response.data);
        this.addFileModal = false;
        this.showModal = false;
      }, 800);
    },
    soundSuccess(file, response) {
      this.$store.commit("setLoadingBtn", true);
      setTimeout(() => {
        this.$store.commit("setSoundUrl", response.data);
        this.addFileModal = false;
        this.showModal = false;
      }, 800);
    },
    allSuccess(file, response) {
      this.$store.commit("setLoadingBtn", true);
      setTimeout(() => {
        this.$store.commit("setUrl", response.data);
        this.addFileModal = false;
        this.showModal = false;
      }, 800);
    },
  },
};
</script>
